import axios from '@/libs/http'

/**
 * 获取公告列表
 * */
export const sysAnnouncementList = (title,content, pageNo, pageSize) => {
    return axios.request({
        url: 's/home/sysAnnouncementList',
        params: {
            title,
            content,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取公告详情
 * */
export const getSysAnnouncement = (id) => {
    return axios.request({
        url: 's/home/getSysAnnouncement',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 获取日志列表
 * */
export const sysUpdateLogList = (title,content, pageNo, pageSize) => {
    return axios.request({
        url: 's/home/sysUpdateLogList',
        params: {
            title,
            content,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取日志详情
 * */
export const getSysUpdateLog = (id) => {
    return axios.request({
        url: 's/home/getSysUpdateLog',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 获取消息tab
 * */
export const getMessageNotice = () => {
    return axios.request({
        url: '/s/a/message-notice/getMessageNotice',
        params: {},
        method: 'get'
    })
}

/**
 * 获取消息列表
 * */
export const noticeLogList = (messageType, pageNo, pageSize) => {
    return axios.request({
        url: '/s/a/message-notice/list',
        params: {
            messageType,
            pageNo,
            pageSize
        },
        method: 'get'
    })
}

/**
 * 获取日志详情
 * */
export const getNoticeLog = (id) => {
    return axios.request({
        url: '/s/a/message-notice/get',
        params: {
            id
        },
        method: 'get'
    })
}

